import React, { memo } from "react";
import { Container } from "@pixi/react";
import { Settings, GAME_LAYOUT } from "../../../settings";
import LineWinTextReel from "./LineWinTextReel";
import GlobalLineWinText from "../../../Components/Animations/GlobalLineWinText/GlobalLineWinText";
import { useReelRefs } from "../../../Contexts/ReelRefsContext";

const LineWinTextReelSet = memo(
  ({ symbolWidth, symbolHeight, reelSpacing }) => {
    const { lineWinTextReelRefs, globalLineWinTextRef } = useReelRefs();

    return (
      <Container
        name="line_win_text_overlay"
        zIndex={6}
        y={-symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5)}
      >
        {/* Only render LineWinTextReel for reels that can show line win text (reels 1 and 2) */}
        {GAME_LAYOUT.REEL_INDICES.map((index) => {
          const canShowLineWinText =
            index === GAME_LAYOUT.MIDDLE_REEL ||
            index === GAME_LAYOUT.SECOND_REEL;

          if (!canShowLineWinText) {
            return null;
          }

          return (
            <LineWinTextReel
              key={index}
              index={index}
              symbolHeight={symbolHeight}
              symbolWidth={symbolWidth}
              reelSpacing={reelSpacing}
              overlaySymbols={GAME_LAYOUT.SYMBOL_INDICES}
              ref={(el) => {
                if (lineWinTextReelRefs) {
                  lineWinTextReelRefs.current[index] = el;
                }
              }}
            />
          );
        })}

        {/* Global Line Win Text - centered in reelset, for scatter wins */}
        <GlobalLineWinText ref={globalLineWinTextRef} />
      </Container>
    );
  }
);

export default LineWinTextReelSet;
